<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_assign"
        title="Aktenprozess"
        @save="saveRecordProcess">
        <h2>Haftpflicht</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="CSP Vollmacht aktivieren"
                property="enableCspAuthorityDocumentCasualty"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="CSP ausblenden"
                property="shouldHideCspCasualty"
                type="checkbox"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Schadensdienstleister"
                :options-loader="loadOptions('damageServiceProvidersByCarDealer', {carDealerId: firmId})"
                property="damageServiceProviderCasualty"
                type="autocomplete"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                v-show="formContext.form.data.damageServiceProviderCasualty"
                class="col-12"
                :form-context="formContext"
                label="AH darf Akte direkt an RA übergeben"
                property="canRecordSkipDspCasualty"
                type="checkbox"/>
        </b-row>
        <h2>Kasko</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="CSP Vollmacht aktivieren"
                property="enableCspAuthorityDocumentComprehensive"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="CSP ausblenden"
                property="shouldHideCspComprehensive"
                type="checkbox"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Schadensdienstleister"
                :options-loader="loadOptions('damageServiceProvidersByCarDealer', {carDealerId: firmId})"
                property="damageServiceProviderComprehensive"
                type="autocomplete"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                v-show="formContext.form.data.damageServiceProviderComprehensive"
                class="col-12"
                :form-context="formContext"
                label="AH darf Akte direkt an RA übergeben"
                property="canRecordSkipDspComprehensive"
                type="checkbox"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Abtretung ausblenden"
                property="shouldNotOverrideComprehensivePaymentOrder"
                type="checkbox"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmRecordProcess',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
        },
        watch: {
            'formContext.form.data.damageServiceProviderCasualty'(newValue) {
                if (newValue) {
                    return;
                }
                // If no dsp is set for casualty, we reset value of canRecordSkipDspCasualty to false
                this.formContext.form.setProperty('canRecordSkipDspCasualty', false)
            },
            'formContext.form.data.damageServiceProviderComprehensive'(newValue) {
                if (newValue) {
                    return;
                }
                // If no dsp is set for comprehensive, we reset value of canRecordSkipDspComprehensive to false
                this.formContext.form.setProperty('canRecordSkipDspComprehensive', false)
            },
        },
        methods: {
            loadOptions(type, urlParameters = {}) {
                return () => {
                    return firmRepository.loadLegacySelectOptions(type, urlParameters);
                }
            },
            saveRecordProcess(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmRecordProcess(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
        },
    }
</script>
